<app-navbar></app-navbar>

<div class="container py-4">
  <!-- Welcome Hero Card -->
  <div class="card mb-4 shadow-sm rounded-4 border-success border-opacity-25">
    <div class="card-body p-4">
      <div class="row g-4 align-items-center">
        <div class="col-12 col-xl-8">
          <small class="text-success fw-bold tracking-wider text-uppercase">WELCOME TO TAITOPOINT.FI</small>
          <h1 class="display-6 display-md-5 fw-bold mt-2">Start your learning journey with clear, practical lessons.
          </h1>
          <p class="text-muted">Explore beginner-friendly courses, track your progress, and keep building your
            confidence every day.</p>
          <div class="d-grid gap-2 d-sm-flex justify-content-sm-start mt-3">
            <button class="btn btn-success btn-lg px-4 shadow-sm">Continue Learning</button>
            <button class="btn btn-outline-success btn-lg px-4">View Schedule</button>
          </div>
        </div>

        <div class="col-12 col-xl-4">
  <div class="card p-4 shadow-sm rounded-4 border-success border-opacity-25 bg-white h-100 d-flex align-items-center justify-content-center">
    <img src="logo.png" alt="Taitopoint Logo" class="img-fluid" style="width: 100%; max-height: 220px; object-fit: contain;">
  </div>
</div>
      </div>
    </div>

    <!-- Main Content Row -->
    <div class="row g-4">
      <!-- Course Sidebar Selection -->
      <div class="col-12 col-md-5 col-lg-4">
        <div class="card p-3 shadow-sm rounded-4 h-100">
          <h5 class="fw-bold mb-3 text-dark">Courses</h5>
          <div class="list-group gap-2 rounded-3 mt-2">
            <div *ngFor="let type of categories" class="list-group-item p-0 border-0">
              <button type="button"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center w-100 rounded-3 p-3 border-start border-4 transition-all"
                [ngClass]="{
                'bg-success bg-opacity-10 text-success border-success fw-bold': selectedCategory.id === type.id, 
                'border-light bg-white text-dark': selectedCategory.id !== type.id
              }" (click)="selectCategory(type)">
                <div>
                  <div class="course-title">{{ type.title }}</div>
                  <small
                    [ngClass]="{'text-success text-opacity-75': selectedCategory.id === type.id, 'text-muted': selectedCategory.id !== type.id}">
                    {{ type.subtitle }}
                  </small>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Active Course & Video Panel -->
      <div class="col-12 col-md-7 col-lg-8">
        <div class="card p-3 p-md-4 shadow-sm rounded-4 h-100">
          <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-2 gap-sm-3 mb-3">
            <div class="flex-grow-1">
              <small class="text-white fw-bold text-uppercase tracking-wide d-block">{{ selectedCategory.title
                }}</small>
              <h3 class="mt-1 mb-1 fw-bold" style="font-size: 1.4rem;">{{ selectedCategory.subtitle }}</h3>
              <p class="text-muted mb-0 small">{{ selectedCategory.description }}</p>
            </div>
            <span
              class="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 align-self-start mt-2 mt-sm-0">Beginner</span>
          </div>

          <!-- Video Player Block -->
          <div *ngIf="currentLesson as lesson" class="mt-2">
            <div
              class="ratio ratio-16x9 rounded-3 rounded-md-4 overflow-hidden shadow-sm border border-light custom-drive-fix">
              <iframe [src]="currentLessonVideoUrl" title="Lesson video" allow="autoplay; encrypted-media"
                allowfullscreen>
              </iframe>
            </div>

            <!-- Active Lesson Metadata -->
            <div class="mt-3 border border-success border-opacity-25 rounded-4 p-3 bg-white bg-opacity-5">
              <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
                <div>
                  <h5 class="mb-1 fw-bold text-success" style="font-size: 1.1rem;">{{ lesson.title }}</h5>
                  <p class="text-dark mb-0 small opacity-75">{{ lesson.summary }}</p>
                </div>
              </div>
            </div>

            <!-- Lesson Navigation Buttons -->
            <div class="mt-4">
              <h6 class="mb-3 text-secondary fw-semibold" style="font-size: 0.95rem;">Choose another lesson</h6>
              <div class="d-flex flex-wrap gap-2">
                <button type="button" *ngFor="let lessonOption of selectedCategory.lessons; let i = index"
                  class="btn btn-sm px-3 rounded-pill transition-all"
                  [ngClass]="{ 'btn-success shadow-sm': selectedLessonIndex === i, 'btn-outline-success': selectedLessonIndex !== i }"
                  (click)="selectLesson(i)">
                  {{ lessonOption.title }}
                </button>
              </div>
            </div>
          </div>

          <!-- Fallback Empty State -->
          <div *ngIf="!currentLesson"
            class="mt-4 alert alert-success bg-success bg-opacity-10 text-success border-success border-opacity-25 mb-0 rounded-4">
            No lessons are available for this category yet.
          </div>

        </div>
      </div>
    </div>
  </div>